<script>

import  {store} from  '../store'
// const App =()=>import('../@App'
//Page Configuration
const pageEmpresa =()=>import('../pages/PageEmpresa')
//End page configuration
const Trimovil =()=>import('../pages/PageTrimovil.vue')
const pageGLP =()=>import('../pages/PageGLP.vue')
const pageGLP2 =()=>import('../pages/PageGLP2.vue')
const pageGNV =()=>import('../pages/PageGNV.vue')
const pageModificacion =()=>import('../pages/PageModificaciones.vue')
const pageReportes =()=>import('../pages/PageReportes.vue')

const DashboardV3 =()=>import('../pages/Dashboard-v3.vue')
const ExtraProfile =()=>import('../pages/Extra-profile.vue')
const Bienvenido =()=>import('../pages/PageBienvenido')

const Personal =()=>import('../pages/PagePersonal')
const Control =()=>import('../pages/control/pages/PageControl')
const ControlDetalles =()=>import('../pages/control/pages/PageControlDetalles')
const Login =()=>import('../pages/PageLogin')
const DefaultContainerVue =()=>import('../DefaultContainer')
const routes = [

  { path: '/login', component: Login },

 
      { 
       beforeEnter: ((to, from, next) => {
         
        next(store.state.auth);
       
      }),
    
    path: '/',  
    redirect: '/login',
    name: 'Automotriz', 
    component: DefaultContainerVue,
    children: [
       { path: '/bienvenido', component: Bienvenido },
       { path: '/inicio', component: DashboardV3 },
       { path: '/personal',  component: Personal },
       { path: '/trimovil',  component: Trimovil },
       { path: '/trimovil/:certificado',  component: Trimovil },
       { path: '/trimovil/:anio/:mes/:idpersona',  component: Trimovil },
       { path: '/glp',  component: pageGLP },
       { path: '/glp/:certificado',  component: pageGLP },
       { path: '/glp/:anio/:mes/:idpersona',  component: pageGLP },
        { path: '/glp2',  component: pageGLP2 },
       { path: '/glp2/:certificado',  component: pageGLP2 },
       { path: '/glp2/:anio/:mes/:idpersona',  component: pageGLP2 },
       { path: '/gnv',  component: pageGNV },
       { path: '/gnv/:anio/:mes/:idpersona',  component: pageGNV },
       { path: '/modificaciones',  component: pageModificacion },
       { path: '/modificaciones/:anio/:mes/:idpersona',  component: pageModificacion },
       { path: '/reportes',  component: pageReportes },
       { path: '/control',  component: Control },
       { path: '/control/detalle/:dni/:personal/:tipo/:inicial/:final', name:'controlDetalle', component: ControlDetalles },
       { path: '/control/detalle',  component: ControlDetalles },
    
       { path: '/configuracion', component: pageEmpresa },
       { path: '/perfil', component: ExtraProfile },
    ]
  }
]
    

export default routes;
</script>
